import { render, staticRenderFns } from "./Showpage.vue?vue&type=template&id=fcfb836a&"
import script from "./Showpage.vue?vue&type=script&lang=ts&"
export * from "./Showpage.vue?vue&type=script&lang=ts&"
import style0 from "./Showpage.vue?vue&type=style&index=0&id=fcfb836a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports